// site.endeca.result.product = jQuery.extend( true, {}, generic.endeca.result.product, {
//   setupQuickShop: function() {
//   }
// });

(function ($, settings) {
  Drupal.behaviors.esearchResultsPCV1 = {
    attached: false,

    attach: function (context, settings) {
      var self = this;

      // Only run this once
      if (self.attached) {
        return;
      }
      self.attached = true;

      var $searchResults = $('.js-end-results', context);
      var $filterToggle = $(
        '.js-filter-toggle, .js-filter-toggle-close, .js-mpp-filter-set__submit',
        $searchResults
      );
      var $searchWrapper = $('.js-search-wrapper__filters', $searchResults);
      var isMobile = $('body').hasClass('device-mobile');

      // add a class so we know search page is loaded
      $('body').addClass('search-page--loaded');

      $filterToggle.on('click', function (event) {
        var $firstCategory = $('.js-results-header', '.js-dimensions__results-wrapper').first();
        $('.js-filter-toggle').toggleClass('collapsed');
        $('.js-filter-toggle').parent().toggleClass('collapsed');
        if (isMobile) {
          $searchWrapper.toggleClass('filtered');
          $('body').toggleClass('fullscreen-enabled');
          $firstCategory.trigger('click');
        }
      });
    }
  };

  $(document).on('endeca.search.results.loaded', function (event, data) {
    var productData = data.results.products.resultData || {};
    // Set a context so that we're not targeting the entire page a second time
    var $c = $('.js-end-results-container');
    // set our grid, detect for Quickshop
    var $grid = $('body').find('.product-grid');
    var $images = $('img[loading="lazy"]', $c);
    var $selectedFilters = $('.js-breadcrumbs__link', '.js-end-results');
    var $filterCount = $('.js-filters-count', '.js-end-results');
    var hasQuickshop = $grid.hasClass('product-grid--quickshop');
    var isMobile = $('body').hasClass('device-mobile');
    var $shadeCarousels = $('.js-product-shade-picker__shades', $c);
    var $multiShadeCarousels = $('.js-product-shade-picker__multi-shades', $c);
    var desktopSlideCountShaded = 5;
    var mobileSlideCountShaded = 7;
    var desktopSlideCountMultiShaded = 4;
    var mobileSlideCountMultiShaded = 6;

    $images.each(function () {
      var imgSrc = $(this).attr('data-src');
      $(this).removeClass('lazyload').attr('src', imgSrc).removeAttr('data-src');
    });

    $shadeCarousels.each(function () {
      var arrowsDiv = $(this).parent().find('.carousel-controls');
      var slides = $(this).parent().find('.js-shade-picker-carousel');
      var slidesToShow = isMobile ? mobileSlideCountShaded : desktopSlideCountShaded;
      var settings = {
        appendArrows: arrowsDiv,
        infinite: false,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToShow
      };
      slides.not('.slick-initialized').slick(settings);
    });

    $multiShadeCarousels.each(function () {
      var arrowsDiv = $(this).parent().find('.carousel-controls');
      var slides = $(this).parent().find('.js-multi-shade-picker-carousel');
      var slidesToShow = isMobile ? mobileSlideCountMultiShaded : desktopSlideCountMultiShaded;
      var settings = {
        appendArrows: arrowsDiv,
        infinite: false,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToShow
      };
      slides.not('.slick-initialized').slick(settings);
    });

    // If there are no product results, then show the no-results layer
    if (productData.length == 0) {
      $('.js-end-summary', $c).show();
      $('.js-best-sellers-search-result-page-content').removeClass('hidden');
      // return;
    } else {
      // Add the product data to the data store
      prodcat.data.updateProducts(productData, false);
    }

    // Initialize the prodcat UI stuff
    if (prodcat.ui && prodcat.ui.init) {
      prodcat.ui.init($c);
    }

    // Quickshop fix
    // reset the grid for qs as we do in the product grid js
    // @todo not sure why this is necessary and it's not caught in the init function
    // but this works
    // @todo review with gendek later
    if (hasQuickshop && prodcat.ui.quickshop) {
      prodcat.ui.quickshop.reset($grid);
      prodcat.ui.quickshop.init($grid);
    }

    if ($selectedFilters.length > 0) {
      // Search tagging for analytics start.
      $('a.js-breadcrumbs__link').on('click', function () {
        var removeFilterSplit = $(this).text().trim().split('(');
        removeFilterSplit = removeFilterSplit[0];
        site.track.evtLink({
          event_name: 'filters_and_sort_selection',
          event_category: 'filter & sort selection',
          event_action: removeFilterSplit,
          event_label: 'X'
        });
        $('.js-end-results-breadcrumbs').addClass('js-filter-remove-search');
      });

      $(document).trigger('search-filter');
      // Search tagging for analytics end.
      $filterCount.text(' (' + $selectedFilters.length + ')');
    } else {
      $filterCount.text('');
    }

    // Now that the product grid JS is in a behavoir, we can just reattach everything with a new context
    Drupal.attachBehaviors($c, settings);

    if (typeof site.l2Request !== 'undefined') {
      site.l2Request.params = site.l2Request.getParams();
      generic.jsonrpc.fetch(site.l2Request);
    }
  });
})(jQuery, Drupal.settings);
